import { useSelector } from 'react-redux';

import { formatNumberAndCents } from '@makemydeal/dr-common-utils';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';

import { ReadOnlyValueRow } from '../../ReadOnlyValueRow';

export const PAID_BY_CUSTOMER_LABEL = 'Paid by Customer';

export const PaidByCustomerRow = () => {
    const paidByCustomer = useSelector(offerReduxSelectors.getCashDueFromCustomer);

    return (
        <ReadOnlyValueRow
            rowKey="paidByCustomer"
            label={PAID_BY_CUSTOMER_LABEL}
            value={`$${formatNumberAndCents(paidByCustomer)}`}
            valueTestId="paid-by-customer-value"
        />
    );
};
